import React from 'react';
import { Typography } from '../../components';
import { useTranslations } from '../../contexts/translation.context';
import IcTg2 from './tg-2.svg';
import IcBlock from './decor-partner.jpg';

export function PartnerNewsBlock() {
  const { t } = useTranslations();
  const telegramAlt = t('global.alt.telegram');

  return (
    <div className="relative rounded-3.5 flex flex-col justify-between overflow-hidden min-h-[14.3125rem] md:min-h-[16.5rem]">
      <div className="absolute inset-x-0">
        {/* <DashboardBlockCreatorIcon style={{minWidth: '431px',width:'100%', height: '288px'}} className='rounded-3.5'/> */}
        <img
          className="rounded-3.5 md:min-w-[26.9375rem] w-full h-full md:h-[16.5rem]"
          src={IcBlock}
          alt=""
        />
      </div>
      <div className="p-4 px-3.5 md:p-6 flex flex-col justify-between h-full z-[2] flex-1">
        <div className="mb-4">
          <span className="block text-xl font-medium text-white mb-2">
            {t('dashboard.newsTitle')}
          </span>
          <span className="block text-base font-normal text-white/80">
            {t('dashboard.newsDescription')}
          </span>
        </div>
        <div className="flex items-center gap-2 mb-2"></div>
        <div className="flex flex-col gap-4">
          {/* <div className='flex flex-col gap-1'>
              <a href="https://t.me/onlyu_offers" target="_blank" rel="noopener noreferrer" className='flex gap-2.5 items-center'>
                <img src={IcTg2} alt={telegramAlt} className='w-[1.375rem] h-[1.375rem]'/>
                <Typography variant='h6' className="text-white mt-[-.25rem]">{t('dashboard.offersChannel')}</Typography>
              </a>
              <Typography variant='body2' className="text-white/80">{t('dashboard.offersChannelDescription')}</Typography>
            </div> */}
          <div className="flex flex-col gap-1 md:px-0 pl-1.5">
            <a
              href="https://t.me/onlyu_news"
              target="_blank"
              rel="noopener noreferrer"
              className="flex gap-2.5 items-center"
            >
              <img src={IcTg2} alt={telegramAlt} className="w-[1.375rem] h-[1.375rem]" />
              <Typography variant="h6" className="text-white mt-[-.25rem]">
                {t('dashboard.newsChannel')}
              </Typography>
            </a>
            <Typography variant="body2" className="text-white/80">
              {t('dashboard.newsChannelDescription')}
            </Typography>
          </div>
        </div>
      </div>
    </div>
  );
}
